<template>
  <a-modal v-model="visible" :footer="null" :maskClosable="false" class="payment-info-contenter" :afterClose="closeHandel" :destroyOnClose="true" key="loginFrm" :width="740">
    <div class="title">
      支付信息
    </div>
    <div class="content">
      <div class="product-info">
        <p class="product">您好，您选择的套餐为<span>{{title}}</span> </p>
        <p class="price">合计: <span>{{price/100}}</span> 元 </p>
      </div>
      <div class="payment-info">
        <div class="tip">
          <span class="price wechat">
            ¥{{price/100}}
          </span>
          请于<span style="color:red">2小时</span>完成二维码扫描支付，过期后将失效请重刷新重新获取二维码。
        </div>
        <div class="payment-qrcode">
          <div class="qrcode">
            <s-qrcode :value="qrCode" :options="{size:180}" v-if="!!qrCode"></s-qrcode>
            <canvas height="180" width="180" v-else></canvas>
          </div>
          <div class="wechat"></div>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";
import PaymentResult from "./PaymentResult";
export default {
  components: {
    "s-qrcode": VueQrcode
  },
  data() {
    return {
      visible: true,
      qrCode: ""
    };
  },
  props: {
    close: Function,
    orderid: String,
    title: String,
    price: Number
  },
  methods: {
    closeHandel(){
      this.close();
      this.checkPaymentStatus=()=>{}
    },
    checkPaymentStatus() {
      this.$http
        .post("/isPay", { orderid: this.orderid })
        .then(res => {
          if(!res.error){
            this.close();
            // this.visible=false;
            // this.$destroy();
            this.$dialog(PaymentResult, {});
          }else{
            switch (res.error) {
              case 10300:
                console.log('无该订单信息');
                break;
              case 10301:
                setTimeout(this.checkPaymentStatus,1000)
                break;
              default:
                break;
            }
          }
        })
        .catch(e => console.error(e));
    }
  },
  created() {
    this.$http
      .post("/qrCodePay", { orderid: this.orderid })
      .then(res => {
        if (!res.error) {
          this.qrCode = res.data.qrCode;
          this.checkPaymentStatus();
        }
      })
      .catch(e => console.log(e));
  }
};
</script>
<style lang="scss" >
@import "~@/components/layout/style/mixin.scss";
.payment-info-contenter {
  .ant-modal-body {
    padding: 0;
  }
  .title {
    width: 100%;
    height: 60px;
    padding: 10px 20px;
    font-size: 16px;
    line-height: 40px;
    background-color: #f3f3f3;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  .content {
    border-top: 1px solid #eee;
    .product-info {
      display: flex;
      border-bottom: 1px solid #bae7ff;
      padding: 20px 0;
      .product {
        border-left: 4px solid #008cd6;
        padding-left: 15px;
        flex: 1;
        text-align: left;

        font-size: 13px;
        color: #666;
        span {
          display: block;
          font-size: 17px;
          color: #333;
        }
      }
      .price {
        width: 120px;
        padding: 18px 0 0 0;
        margin: 0 20px 0 0;
        text-align: right;
        font-size: 15px;
        font-weight: bold;
        span {
          font-size: 18px;
          color: #f00;
        }
      }
    }
    .payment-info {
      margin: auto;
      & > div {
        width: 450px;
      }
      .tip {
        font-size: 12px;
        color: #999;    
        margin-bottom: 10px;
        .wechat:before {
          content: "";
          vertical-align: middle;
          display: inline-block;
          @include menu-icon;
          background-position: -190px -155px;
          width: 145px;
          height: 45px;
          margin: 0 0 0 -57px;
        }
        .price {
          display: block;
          font-size: 16px;
          color: #f00;
        }
      }
      .payment-qrcode {
        margin-bottom: 20px;
        & > div {
          display: inline-block;
        }
        .qrcode {
          margin: 0;
          height: 180px;
          width: 180px;
          &:after {
            content: "";
            display: inline-block;
            @include menu-icon;
            background-position: -200px -200px;
            width: 180px;
            height: 45px;
            margin: 10px 0 0 0;
          }
        }
        .wechat {
          @include menu-icon;
          background-position: -380px -160px;
          width: 190px;
          height: 250px;
          margin: 0 0 0 70px;
          vertical-align: top;
        }
      }
    }
    .footer {
      height: 70px;
      border-top: 1px solid #eee;
      background-color: #f6fcff;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      text-align: right;
      button {
        border-radius: 0px;
        width: 135px;
        height: 36px;
        margin-top: 15px;
        margin-right: 20px;
        font-size: 16px;
      }
    }
  }
}
</style>
